<ng-container *ngIf="section.type === 'section' && section.visible !== false">
  <details [open]="expanded" (toggle)="onToggle($event)">
    <summary>{{section.description}}</summary>
    <ng-content></ng-content>
  </details>
</ng-container>
